<template>
    <!-- Nav Item - Notifications -->
    <li class="nav-item dropdown no-arrow mx-1">
        <a aria-expanded="false" aria-haspopup="true" class="nav-link dropdown-toggle" data-toggle="dropdown" href="#"
           id="notificationsDropdown" role="button" v-on="{ click: readNotifications }">
            <i class="fas fa-bell fa-fw"></i>
            <!-- Counter - Notifications -->
            <span class="badge badge-danger badge-counter" v-if="unread > 0">{{ unread }}</span>
        </a>
        <!-- Dropdown - Notifications -->
        <div aria-labelledby="notificationsDropdown"
             class="dropdown-list dropdown-menu dropdown-menu-right shadow animated--grow-in">
            <h6 class="dropdown-header">
                Notifications Center
            </h6>
            <a :href="notification.action_url" class="dropdown-item d-flex align-items-center"
               v-for="notification in notifications">
                <div class="mr-3">
                    <div :class="notification.notification_class" class="icon-circle">
                        <i :class="notification.notification_icon" class="text-white"></i>
                    </div>
                </div>
                <div>
                    <div class="small text-gray-500">{{ notification.date }}</div>
                    <span v-bind:class="{ 'font-weight-bold': notification.unread }">{{ notification.text }}</span>
                </div>
            </a>
            <h6 class="dropdown-item text-center small text-gray-500" v-if="total === 0">No Notifications.</h6>
            <a :href="indexUrl" class="dropdown-item text-center small text-gray-500" v-else>Show All Notifications</a>
        </div>
    </li>
</template>

<script>
    export default {

        name: "Notifications",

        props: ['getUrl', 'readUrl', 'indexUrl'],

        mounted() {
            this.getNotifications();
        },

        data: function () {
            return {
                notifications: [],
                unread: 0,
                total: 0
            };
        },

        methods: {
            getNotifications: function () {
                let $this = this;

                axios
                    .get($this.getUrl)
                    .then(response => {
                        $this.notifications = response.data.notifications;
                        $this.unread = response.data.unread_count;
                        $this.total = response.data.total_count;
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            readNotifications: function () {
                let unreadIds = [];

                this.notifications.forEach(notification => {
                    if (notification.unread) unreadIds.push(notification.notification_id);
                });

                if (unreadIds.length) {
                    axios
                        .put(this.readUrl, {
                            unreadIds: unreadIds
                        })
                        .then(function (response) {
                            console.log(response);
                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                }
            }
        }
    }
</script>
